// extracted by mini-css-extract-plugin
export var fadeInOut = "_p-3";
export var icon = "_p-4";
export var savedIndicator = "_p-2";
export var savingIndicator = "_p-0";
export var spin = "_p-1";